import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface OriginalFormData {
  recordType: 'claim' | 'inquiry';
  claim: any;
  vessel: any;
  equipment: any;
  product: any;
  category: any;
  shipyard: any;
  owner: any;
  company: any;
  files: any[];
  openVessel?: (vessel: any) => void;
  openCompany?: (company: any) => void;
  downloadFile?: (id: string, name: string, type: string) => void;
}

@Component({
  selector: 'app-original-form',
  templateUrl: './original-form.component.html',
  styleUrl: './original-form.component.css'
})
export class OriginalFormComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OriginalFormData,
    private dialogRef: MatDialogRef<OriginalFormComponent>,
  ) {}

  openVessel(): void {
    if (!this.data.vessel || !this.data.openVessel) return;
    this.dialogRef.close();
    this.data.openVessel(this.data.vessel);
  }

  openShipyard(): void {
    if (!this.data.shipyard || !this.data.openCompany) return;
    this.dialogRef.close();
    this.data.openCompany(this.data.shipyard);
  }

  downloadFile(id: string, name: string, type: string): void {
    this.data.downloadFile?.(id, name, type);
  }

  formatFileSize(bytes: number): string {
    if (bytes == null) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
}